/**
 * Returns the prefer header with the best practice of respond-async,wait=30.
 * Sherbert fetch handles 202 responses automatically.
 * @returns The prefer header.
 */
export const preferHeader = () => ({ Prefer: "respond-async,wait=30" });
